

















import {Component, Prop, Vue} from "vue-property-decorator";
import {EmployeeStore} from "@/modules/employees/store";
import {Employee} from "@/interfaces/entity";

@Component({
    name: "EmployeeTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly employeeId!: string;

    get employee(): Employee {
        return EmployeeStore.data[this.employeeId];
    }

    set employee(value: Employee) {
        EmployeeStore.data[this.employeeId] = value;
    }
    async onConfirm() {
        try {
            await EmployeeStore.deleteEmployee(this.employeeId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa nhân viên thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa nhân viên thất bại"
            });
        }
    }
}
